import React from "react";
import { TabProps } from "../../../../SourceModal.types";
import { getSourceDisplayName } from "../../../../SourceModal.config";
import BaseOverview from "./BaseOverview";
import FileUploadOverview from "./FileUploadOverview";

const FileOverview: React.FC<TabProps> = ({
    source,
    language,
    onRefresh,
    onClose,
    mode,
}) => {
    const sourceCode = source?.source_type?.code;
    const displayName = getSourceDisplayName(
        sourceCode,
        source?.source_type?.name,
    );

    const getDescription = () => {
        switch (sourceCode) {
            case "ftp":
            case "sftp":
                return `Connect to your ${sourceCode?.toUpperCase()} server to automatically import and process data files. This source enables scheduled data imports from your file server to SignalSight.`;
            case "upload":
                return "Upload data files directly to SignalSight. Supports CSV and other common file formats for batch data processing.";
            case "spreadsheet":
                return "Connect your Google Spreadsheet to automatically sync data. Changes in your spreadsheet will be processed and sent to your configured destinations.";
            case "bigquery":
                return "Connect to Google BigQuery to import and process large datasets. This integration enables powerful analytics and data synchronization.";
            default:
                return "Connect your file-based data source to SignalSight for automated data processing and synchronization.";
        }
    };

    if (mode === "standalone") return <BaseOverview language={language} />;

    // For upload source type, show file upload interface using reusable component
    if (sourceCode === "upload") {
        return (
            <BaseOverview
                language={language}
                title={displayName}
                showDataPointOverview={false}
                showDescription={false}
            >
                <FileUploadOverview
                    sourceId={source?.id}
                    sourceType={sourceCode}
                    language={language}
                    onRefresh={onRefresh}
                    onClose={onClose}
                    newFileCheck={true}
                />
            </BaseOverview>
        );
    }

    // For other file sources (ftp, sftp, spreadsheet, bigquery), show standard overview
    return (
        <BaseOverview language={language} title={displayName}>
            <div>
                <p>{getDescription()}</p>
                <div className="mt-3">
                    <h3 className="mb-2">Data Processing Features:</h3>
                    <ul
                        style={{ paddingLeft: "1.5rem", listStyleType: "disc" }}
                    >
                        <li>Automated file processing</li>
                        <li>Column mapping support</li>
                        <li>Data validation and error handling</li>
                        <li>Processing history and logs</li>
                    </ul>
                </div>
            </div>
        </BaseOverview>
    );
};

export default FileOverview;
